import React from "react";
import {findDOMNode} from "react-dom";
import HintPopover from "../../../core/gd-ui/hint-popover/hint-popover";
import MainMenu_MoreButton from "./menu-more";
import NavigationSection from "../../../core/model2/navigation/navigation-section";
import MoreProject_PopoverMenu from "../../../core/gd-ui/more/project/popover-menu";
import PopoverMenu from "../../../core/gd-components/popover-menu/popover-menu/popover-menu";

type State = {
    useHint : boolean
}

export enum CounterType {

    BLUE_NUMBER = 0,
    GRAY_NUMBER = 1,
    BLUE_BOX    = 2,
    GRAY_BOX     = 3,

}

type Props = {

    navigationSection?  : NavigationSection

    onClick?            : callback,     //
    url?                : string,       // if static URL

    name                : string,
    icon?               : string,
    style?              : any,
    className?          : string,

    //
    counter?            : number,
    counterStyle?       : CounterType,


    selected?           : boolean,


    onMoreClick?        : callback,
    moreMenuOptions?    : Option[]
    iconMoreClass?      : string    // icon more class


    dndPreview?         : any,
    dndIsDragged?       : boolean,
    upgradeRequired?    : any // UPGRADE_PRO | UPGRADE_BUSINESS | false,

    isShared?           : boolean
    showArrow?          : boolean
    showLongArrow?      : boolean       // used in NavigationMenuItemSectionLink - show right long arrow

    saveUrl?            : boolean       // if true - save url in section default app url

    children?           : any   // used when we have popover i.e. personal views more button

}

export default class NavigationMenuItem extends React.Component<Props, State> {

    private debouncedCheckHint  : any

    static defaultProps = {
        saveUrl     : true
    }

    constructor(props: Props) {
        super(props);

        this.state = {
            useHint: false
        };

        this.debouncedCheckHint = _.debounce(this._checkHintUsage, 300);
    }

    showContextMenu = (e:React.MouseEvent) => {
        if (!this.props.moreMenuOptions) return

        gd.layout.contextMenu.show(e,
            <PopoverMenu options        = {this.props.moreMenuOptions}
                         className      = "w-220"
                         hidePopover    = {gd.layout.contextMenu.hide} />
            ,
            {
                component: this,
                className   : 'hovered'
            }
        )
    }

    onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()

        if (this.props.upgradeRequired) {
            gd.modals.other.upgrade(this.props.upgradeRequired)
            return
        }

        if (this.props.url) {

            if (this.props.navigationSection && this.props.saveUrl) {
                this.props.navigationSection.defaultAppUrl = this.props.url
            }

            gd.goTo(this.props.url)

        } else if (this.props.onClick) {
            this.props.onClick()
        } else {
            console.error("#MenuITem-1 no url/onClick")
        }
    }

    componentDidMount() {
        this.debouncedCheckHint();
    }

    componentDidUpdate() {
        this.debouncedCheckHint();
    }

    componentWillUnmount = () => {
        this.debouncedCheckHint.cancel();
    };

    _checkHintUsage = () => {
        const useHint = gd.utils.getTextExceedsNodeWidth(this.props.name, findDOMNode(this), 56, 14);

        if (this.state.useHint !== useHint) {
            this.setState({
                useHint: useHint
            })
        }
    };

    render() {
        const classes = Classes('item', this.props.className, {
            selected            : this.props.selected,
            'dnd-preview'       : this.props.dndPreview,
            'dnd-is-dragged'    : this.props.dndIsDragged,
        });

        let counter = null
        if (this.props.counter && this.props.counter>0) {

            const counterClass = Classes('counter', {
                'blue'      : this.props.counterStyle === CounterType.BLUE_NUMBER,
                'gray'      : this.props.counterStyle === CounterType.GRAY_NUMBER,
                'blue-box'  : this.props.counterStyle === CounterType.BLUE_BOX,
                'gray-box'  : this.props.counterStyle === CounterType.GRAY_BOX,
            })

            counter = <div className={counterClass}>{this.props.counter}</div>
        }


        const showMoreButton = !_.isEmpty(this.props.moreMenuOptions)

        // style is required for ReorderList (pointer-events: none)
        return (
            <div className={classes} style={this.props.style} onClick={this.onClick} onContextMenu={this.showContextMenu}>
                <div className="row">
                    <div className={Classes('icon', this.props.icon)}/>
                    <div className="name">{this.props.name}</div>
                    {this.props.onMoreClick && <div className="more ui5-ico-more s20 btn-more-target" onClick={this.props.onMoreClick}/>}

                    {showMoreButton &&
                        <MainMenu_MoreButton menuOptions    = {this.props.moreMenuOptions!}
                                             iconClass      = {this.props.iconMoreClass}/>}

                    {this.props.isShared && <div className="btn-shared i5-inherited" />}
                    {counter}
                    {this.props.showArrow && <div className="right-arrow ui5-ico-12 i5-angle-right"/>}
                    {this.props.showLongArrow && <div className="right-arrow ui5-ico-12 i5-long-arrow-right"/>}
                </div>

                {this.state.useHint &&
                    <HintPopover parent={this} hint={this.props.name} multiline={true}/>
                }

                {this.props.children}
            </div>
        )
    }
}
